import actionTypes from "../actionTypes";
import {INewParcelaSection, IPointCoords, ISistemasProduccion} from "../../types";
import {LatLngTuple} from "leaflet";

const update = require('immutability-helper');


export const initialState = {
    seccion: 'Caracterización' as INewParcelaSection,
    propietario: '' as string,
    nombre: '' as string,
    huso: 30 as number,
    banda: 'N' as string,
    polygon: [] as LatLngTuple[],
    sectores: {} as Record<string, LatLngTuple[]>,
    editando: false as boolean,
    cultivo: '' as string,
    estacion_metereologica: {
        urls: {} as Record<string, Record<string, Record<string, string>>>,
        comunidad: '' as string,
        provincia: '' as string,
        estacion: '' as string,
        elTiempo_url: '' as string
    },
    id_estacion: 0 as number,
    ubicacion_estacion: "" as string,
    coordenadas_estacion: {} as IPointCoords,
    sistema: null as null | ISistemasProduccion,
    marco: '0x0' as string,
    diametro: 0 as number,
    textura: '' as string,
    limiteHa: 0 as number,
    fecha: '' as string,
    dias: '1,0,0,0,0,0,0'
};

export function reducer(state: typeof initialState=initialState, action: actionTypes) {
    switch (action.type) {

        case 'select-crear-parcela-seccion':
            return update(state, {seccion: {$set: action.seccion}});

        case 'set-crear-parcela-propietario':
            return update(state, {propietario: {$set: action.propietario}});

        case 'set-crear-parcela-nombre':
            return update(state, {nombre: {$set: action.nombre}});

        case 'set-crear-parcela-huso':
            return update(state, {huso: {$set: action.huso}});

        case 'set-crear-parcela-banda':
            return update(state, {banda: {$set: action.banda}});

        case 'set-crear-parcela-polygon':
            return update(state, {polygon: {$set: action.polygon}});

        case 'set-crear-parcela-sectores':
            return update(state, {sectores: {$set: action.sectores}});

        case 'set-crear-parcela-editando':
            return update(state, {editando: {$set: action.editando}});

        case 'set-crear-parcela-cultivo':
            return update(state, {cultivo: {$set: action.cultivo}});

        case 'set-crear-parcela-comunidad':
            return update(state, {
                estacion_metereologica: {comunidad: {$set: action.comunidad}}
            });

        case 'set-crear-parcela-provincia':
            return update(state, {
                estacion_metereologica: {provincia: {$set: action.provincia}}
            });

        case 'set-crear-parcela-estacion':
            return update(state, {
                estacion_metereologica: {estacion: {$set: action.estacion}}
            });

        case 'set-crear-parcela-elTiempo-url':
            return update(state, {
                estacion_metereologica: {elTiempo_url: {$set: action.url}}
            });

        case 'set-crear-parcela-urls':
            return update(state, {
                estacion_metereologica: {urls: {$set: action.urls}}
            });

        case 'set-crear-parcela-id_estacion':
            return update(state, {id_estacion: {$set: action.id_estacion}});

        case 'set-crear-parcela-ubicacion_estacion':
            return update(state, {ubicacion_estacion: {$set: action.ubicacion_estacion}});

        case 'set-crear-parcela-coordenadas_estacion':
            return update(state, {coordenadas_estacion: {$set: action.coordenadas_estacion}});

        case 'set-crear-parcela-sistema':
            return update(state, {sistema: {$set: action.sistema}});

        case 'set-crear-parcela-marco':
            return update(state, {marco: {$set: action.marco}});

        case 'set-crear-parcela-diametro':
            return update(state, {diametro: {$set: action.diametro}});

        case 'set-crear-parcela-textura':
            return update(state, {textura: {$set: action.textura}});

        case 'set-crear-parcela-limiteHa':
            return update(state, {limiteHa: {$set: action.limiteHa}});

        case 'set-crear-parcela-fecha':
            return update(state, {fecha: {$set: action.fecha}});

        case 'set-crear-parcela-dias':
            return update(state, {dias: {$set: action.dias}});

        default:
            return state
    }
}
